import api from "@/services/api";
import { ENDPOINTS_LEADERBOARD } from "@/services/endpoints";

export const listLeaderboard = () => api.get(ENDPOINTS_LEADERBOARD.list).then((r) => r.data);
